"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginPage = void 0;
var react_1 = __importStar(require("react"));
var react_helmet_1 = require("react-helmet");
var UserManager_1 = __importDefault(require("App/util/UserManager"));
var react_redux_1 = require("react-redux");
var context_1 = require("App/context");
var connected_react_router_1 = require("connected-react-router");
var Loader_1 = __importDefault(require("App/components/Loader"));
var env_1 = require("App/util/env");
var LoadableLogo_1 = __importDefault(require("App/components/LoadableLogo"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var axios_1 = __importDefault(require("axios"));
var env = env_1.getEnv({
    OIDC_SIGNIN_TYPE: process.env.REACT_APP_OIDC_SIGNIN_TYPE || 'redirect',
    SSO_CHECK_API_URL: process.env.REACT_APP_SSO_CHECK_API_URL || ''
});
exports.LoginPage = function () {
    var ctx = react_1.useContext(context_1.ApplicationContext);
    var dispatch = react_redux_1.useDispatch();
    var loginCallback = function () {
        if (ctx.extraQueryParams === undefined) {
            ctx.extraQueryParams = {};
        }
        if (ctx.extraTokenParams === undefined) {
            ctx.extraTokenParams = {};
        }
        ctx.extraQueryParams.hootsuiteUserId = window.sessionStorage.getItem('hootsuiteUserId');
        ctx.extraQueryParams.hootsuiteTimestamp = window.sessionStorage.getItem('hootsuiteTimestamp');
        ctx.extraQueryParams.hootsuitePlacementId = window.sessionStorage.getItem('hootsuitePlacementId');
        ctx.extraQueryParams.hootsuiteToken = window.sessionStorage.getItem('hootsuiteToken');
        ctx.extraQueryParams.messageId = window.sessionStorage.getItem('messageId');
        ctx.extraTokenParams.hootsuiteUserId = window.sessionStorage.getItem('hootsuiteUserId');
        ctx.extraTokenParams.hootsuiteTimestamp = window.sessionStorage.getItem('hootsuiteTimestamp');
        ctx.extraTokenParams.hootsuitePlacementId = window.sessionStorage.getItem('hootsuitePlacementId');
        ctx.extraTokenParams.hootsuiteToken = window.sessionStorage.getItem('hootsuiteToken');
        ctx.extraTokenParams.messageId = window.sessionStorage.getItem('messageId');
        window.sessionStorage.removeItem('hootsuiteUserId');
        window.sessionStorage.removeItem('hootsuiteTimestamp');
        window.sessionStorage.removeItem('hootsuitePlacementId');
        window.sessionStorage.removeItem('hootsuiteToken');
        window.sessionStorage.removeItem('messageId');
        dispatch(connected_react_router_1.push('/'));
        UserManager_1.default.events.removeUserLoaded(loginCallback);
    };
    react_1.default.useEffect(function () {
        if (ctx !== undefined && ctx.extraQueryParams !== undefined) {
            window.sessionStorage.setItem('hootsuiteUserId', ctx.extraQueryParams.hootsuiteUserId);
            window.sessionStorage.setItem('hootsuiteTimestamp', ctx.extraQueryParams.hootsuiteTimestamp);
            window.sessionStorage.setItem('hootsuitePlacementId', ctx.extraQueryParams.hootsuitePlacementId);
            window.sessionStorage.setItem('hootsuiteToken', ctx.extraQueryParams.hootsuiteToken);
            window.sessionStorage.setItem('messageId', ctx.extraQueryParams.messageId);
            if (env.OIDC_SIGNIN_TYPE === 'popup') {
                var params = {
                    hootsuiteUserId: ctx.extraQueryParams.hootsuiteUserId,
                    hootsuiteTimestamp: ctx.extraQueryParams.hootsuiteTimestamp,
                    hootsuitePlacementId: ctx.extraQueryParams.hootsuitePlacementId,
                    hootsuiteToken: ctx.extraQueryParams.hootsuiteToken,
                    messageId: ctx.extraQueryParams.messageId
                };
                axios_1.default.get(env.SSO_CHECK_API_URL, { params: params }).then(function (response) {
                    var ssoTokenResponse = response.data;
                    if (ssoTokenResponse.tokenAvailable) {
                        UserManager_1.default.signinRedirect({
                            extraQueryParams: ctx.extraQueryParams,
                            extraTokenParams: ctx.extraTokenParams
                        });
                    }
                    else {
                        UserManager_1.default.events.addUserLoaded(loginCallback);
                        var defaultPopupFeatures_1 = 'location=no,toolbar=no,width=500,height=600,left=100,top=100;';
                        var defaultPopupTarget_1 = "_blank";
                        UserManager_1.default.createSigninRequest({
                            extraQueryParams: ctx.extraQueryParams,
                            extraTokenParams: ctx.extraTokenParams,
                            redirect_uri: UserManager_1.default.settings.popup_redirect_uri
                        }).then(function (signinRequest) {
                            window.open(signinRequest.url, defaultPopupTarget_1, defaultPopupFeatures_1);
                        });
                        /*userManager.signinPopup({
                          extraQueryParams: ctx.extraQueryParams,
                          extraTokenParams: ctx.extraTokenParams
                        })*/
                    }
                });
            }
            else {
                UserManager_1.default.signinRedirect({
                    extraQueryParams: ctx.extraQueryParams,
                    extraTokenParams: ctx.extraTokenParams
                });
            }
        }
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.Helmet, { title: "Login" }),
        env.OIDC_SIGNIN_TYPE === 'popup' ? (react_1.default.createElement("div", { className: "popupInfo" },
            react_1.default.createElement(LoadableLogo_1.default, null),
            react_1.default.createElement("div", { className: "info" },
                react_1.default.createElement("span", { className: "icon" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faWindowRestore })),
                "Please authenticate using the popup. The popup can be blocked by the browser, if this is the case please unblock the popups for this website."),
            react_1.default.createElement(Loader_1.default, null))) : (react_1.default.createElement(Loader_1.default, null))));
};
exports.default = {
    name: 'Login',
    routeProps: {
        path: '/login',
        component: exports.LoginPage,
    },
};
//# sourceMappingURL=login.js.map